module.exports = __webpack_public_path__ + "static/media/pen.f9648c50.png";